import ServerVariablesSelect_default from "./ServerVariablesSelect.vue.js";
import ServerVariablesTextbox_default from "./ServerVariablesTextbox.vue.js";
import { Fragment, createBlock, createCommentVNode, createElementBlock, createElementVNode, defineComponent, normalizeClass, openBlock, renderList, renderSlot, toDisplayString, unref, useId, useSlots } from "vue";
//#region src/components/Server/ServerVariablesForm.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "flex h-8 w-full items-center" };
var _hoisted_2 = ["for"];
var _hoisted_3 = ["id"];
var ServerVariablesForm_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ServerVariablesForm",
	props: {
		variables: {},
		values: {},
		controls: {},
		layout: { default: "client" }
	},
	emits: ["update:variable"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		/** Optional read-only context for individual variables, kept separate from their editable values. */
		const slots = useSlots();
		const id = useId();
		function setVariable(name, value) {
			emit("update:variable", name, value);
		}
		const getVariable = (name) => {
			return (__props.values?.[name] ?? __props.variables?.[name]?.default ?? "").toString();
		};
		return (_ctx, _cache) => {
			return __props.variables && Object.keys(__props.variables ?? {}).length ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(Object.keys(__props.variables), (name) => {
				return openBlock(), createElementBlock("div", {
					key: name,
					class: normalizeClass(["group/label w-full", __props.layout === "reference" && "border-x border-b last:rounded-b-lg"])
				}, [createElementVNode("div", _hoisted_1, [createElementVNode("label", {
					class: "flex items-center py-2 pl-3 group-has-[input]/label:mr-0 after:content-[':']",
					for: `${unref(id)}-${name}`
				}, toDisplayString(name), 9, _hoisted_2), __props.variables?.[name]?.enum?.length ? (openBlock(), createBlock(ServerVariablesSelect_default, {
					key: 0,
					id: `${unref(id)}-${name}`,
					controls: __props.controls,
					describedBy: slots[`hint-${name}`] ? `${unref(id)}-${name}-hint` : void 0,
					enum: __props.variables[name]?.enum?.map((v) => `${v}`) ?? [],
					value: getVariable(name),
					onChange: (s) => setVariable(name, s)
				}, null, 8, [
					"id",
					"controls",
					"describedBy",
					"enum",
					"value",
					"onChange"
				])) : (openBlock(), createBlock(ServerVariablesTextbox_default, {
					key: 1,
					id: `${unref(id)}-${name}`,
					"aria-describedby": slots[`hint-${name}`] ? `${unref(id)}-${name}-hint` : void 0,
					controls: __props.controls,
					value: getVariable(name),
					onChange: (s) => setVariable(name, s)
				}, null, 8, [
					"id",
					"aria-describedby",
					"controls",
					"value",
					"onChange"
				]))]), slots[`hint-${name}`] ? (openBlock(), createElementBlock("div", {
					key: 0,
					id: `${unref(id)}-${name}-hint`,
					class: "text-c-2 px-3 pb-2 text-sm"
				}, [renderSlot(_ctx.$slots, `hint-${name}`)], 8, _hoisted_3)) : createCommentVNode("", true)], 2);
			}), 128)) : createCommentVNode("", true);
		};
	}
});
//#endregion
export { ServerVariablesForm_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ServerVariablesForm.vue_vue_type_script_setup_true_lang.js.map